<template>
  <ToolbarItemContainer
    :iconFile="imageToolbarForShow.icon"
    :title="imageToolbarForShow.title"
    iconWidth='20px'
    iconHeight='20px'
    :needDialog="false"
    @onIconClick="onIconClick"
    :isH5ToolShow="isH5ToolShow"
  >
    <div
      :class="['image-upload', !isPC && 'image-upload-h5','image-video']"
    >
      <input
        ref="inputRef"
        :title="props.title || TUITranslateService.t('图片')"
        type="file"
        accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp,video/mov,video/mp4"
        @change="sendImageInWeb"
      >
    </div>
  </ToolbarItemContainer>
</template>
<script lang="ts">
import { TUIChatService, TUIStore, StoreName, IConversationModel, SendMessageParams, SendMessageOptions, TUITranslateService } from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import { isPC, isH5 } from '../../../../utils/env';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import imageIcon from '../../../../assets/image.svg';
import imageUniIcon from '../../../../assets/image-uni.png';
import { getTo, isEnabledMessageReadReceiptGlobal } from '../../../../utils/utils';
import Log from '../../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';
const __sfc_main = {};
__sfc_main.props = {
  // Image source: only valid for uni-app version, web version only supports selecting images from the album.
  // album: Select from album
  // camera: Take a photo using the camera
  imageSourceType: {
    type: String,
    default: 'album'
  },
  isH5ToolShow: {
    type: Boolean,
    default: false
  },
  title: {
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    computed
  } = vue;
  const props = __props;
  const inputRef = ref();
  const currentConversation = ref<IConversationModel>();
  const IMAGE_TOOLBAR_SHOW_MAP = {
    web_album: {
      icon: imageIcon,
      title: props.title || TUITranslateService.t("图片")
    },
    uni_album: {
      icon: imageUniIcon,
      title: props.title || TUITranslateService.t("图片")
    }
  };
  TUIStore.watch(StoreName.CONV, {
    currentConversation: (conversation: IConversationModel) => {
      currentConversation.value = conversation;
    }
  });
  const imageToolbarForShow = computed((): {
    icon: string;
    title: string;
  } => {
    if (isH5) {
      return IMAGE_TOOLBAR_SHOW_MAP['uni_album'];
    } else {
      return IMAGE_TOOLBAR_SHOW_MAP['web_album'];
    }
  });
  const onIconClick = () => {
    if (inputRef.value?.click) {
      inputRef.value.click();
    }
  };
  const sendImageInWeb = (e: any) => {
    if (e?.target?.files?.length <= 0) {
      return;
    }
    const file = e.target.files[0];
    if (!file || !file.size) {
      return;
    }
    if (file.type.startsWith('image/')) {
      // 处理图片文件
      sendImageMessage(e.target);
    } else if (file.type.startsWith('video/')) {
      // 处理视频文件
      sendVideoMessage(e.target);
    }
    e.target.value = '';
  };
  const sendImageMessage = (files: any) => {
    if (!files) {
      return;
    }
    const options = {
      to: getTo(currentConversation?.value),
      conversationType: currentConversation?.value?.type,
      payload: {
        file: files
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal()
    } as SendMessageParams;
    const sendMessageOptions: SendMessageOptions = {};
    TUIChatService.sendImageMessage(options, sendMessageOptions).catch(err => {
      Toast({
        message: err.code === 2253 ? TUITranslateService.t('AIDesk.image 大小超过 20MB，无法发送') : err.message,
        type: TOAST_TYPE.ERROR,
        duration: 5000
      });
      Log.l(`Send Image Failed:${err.code} ${err.message}`);
    });
  };
  const sendVideoMessage = (file: any) => {
    if (!file) {
      return;
    }
    const options = {
      to: getTo(currentConversation?.value),
      conversationType: currentConversation?.value?.type,
      payload: {
        file
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal()
    } as SendMessageParams;
    const sendMessageOptions: SendMessageOptions = {};
    TUIChatService.sendVideoMessage(options, sendMessageOptions).catch(err => {
      Toast({
        message: err.code === 2351 ? TUITranslateService.t('AIDesk.video 大小超过 100MB，无法发送') : err.message,
        type: TOAST_TYPE.ERROR,
        duration: 5000
      });
      Log.l(`Send Video Failed:${err.code} ${err.message}`);
    });
  };
  return {
    TUITranslateService,
    isPC,
    props,
    inputRef,
    imageToolbarForShow,
    onIconClick,
    sendImageInWeb
  };
};
__sfc_main.components = Object.assign({
  ToolbarItemContainer
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
@import "../../style/common";
</style>
